import { useAuthentication } from '@/components/auth/AuthProvider'

export default function useIsSuperUser() {
  const { user } = useAuthentication()
  return user ? user.resolved_permission_codes.includes('*superuser*') : false
}
